import { useRouter } from "next/compat/router";
import { useEffect } from "react";
import type Stripe from "stripe";
import useSWRImmutable from "swr/immutable";

import useGlobalStore from "./useGlobalStore";

const usePromoCode = () => {
	const { promo = null } = (useRouter()?.query ?? {}) as {
		promo: string | null;
	};

	const { promoCodeParam = promo, setPromoCodeParam } = useGlobalStore();

	useEffect(() => {
		if (!promoCodeParam && promo) {
			setPromoCodeParam(promo);
		}
	}, [promo, promoCodeParam, setPromoCodeParam]);

	const {
		data: promoCode,
		isLoading,
		error,
	} = useSWRImmutable<Stripe.PromotionCode>(
		promoCodeParam && `/stripe/promo-codes/${promoCodeParam}`,
	);

	useEffect(() => {
		error &&
			setTimeout(() => {
				setPromoCodeParam(null);
				console.error("Error fetching promo code:", error);
			}, 3000);
	}, [error, setPromoCodeParam]);

	return {
		promoCode,
		isLoadingPromoCode: isLoading,
		applyPromoCode: setPromoCodeParam,
		removePromoCode: () => setPromoCodeParam(null),
		promoCodeParam,
		notFound: error?.response?.status === 404,
	};
};

export default usePromoCode;
